module.exports = {
    SCHEDULE_SETTINGS_CHANGED: 'SCHEDULE_SETTINGS_CHANGED',
};
